import React from "react"
import styled from "styled-components"
import BraveGIF from "../images/braveBrowser.gif"
const BraveBanner = () => (
  <Brave
    onClick={() => {
      window.location.href = "https://brave.com/how080"
    }}
    src={BraveGIF}
  />
)

export default BraveBanner

const Brave = styled.img`
  cursor: pointer;
  width: 40%;
  border-radius: 5px;
  margin-top: 20px;
  @media only screen and (min-width: 20px) and (max-width: 768px) {
    width: 95%;
  }
`
